/*
 * @Author: lixin jiang
 * @Date: 2021-07-14 17:55:51
 * @LastEditTime: 2021-07-14 19:03:00
 * @LastEditors: lixin jiang
 * @Description:
 * @FilePath: /aid-base/src/components/ColorChoice/index.js
 * @
 */

import ColorChoice from './colorChoice';

export default ColorChoice;
